import _concat from 'lodash/concat';
import _defaultTo from 'lodash/defaultTo';
import _forEach from 'lodash/forEach';
import _map from 'lodash/map';
// Serialization
import { serialize } from 'serializr';
import { rightSchema } from './schemas';
// Models
import mPeriod from './period';
import mScenario from './scenario';

/**
* Serialization
*/
const serializeRight = ({
  scenarioTriggerId, begin, end, enabled, planningId,
}) => ({
  ...serialize(rightSchema, {
    scenario_trigger_id: _defaultTo(scenarioTriggerId, null),
    begin,
    end,
    enabled,
    planning_id: _defaultTo(planningId, null),
  }),
});

/**
* Utils
*/
const sortRights = (rights) => (
  rights.sort((r1, r2) => {
    if (r1.scenario_trigger_id !== r2.scenario_trigger_id) {
      return r1.scenario_trigger_id - r2.scenario_trigger_id;
    }
    if (!r1.begin) {
      return -1;
    }
    if (!r2.begin) {
      return 1;
    }
    return r1.begin.localeCompare(r2.begin);
  })
);

const rightIsEqual = (right1, right2) => (
  right1.scenario_trigger_id === right2.scenario_trigger_id && mPeriod.id(right1) === mPeriod.id(right2)
);

const getAllRightsFromAccessWayType = (scenarios, devices, type) => {
  const filteredScenarios = mScenario.filterByAccessWayType(scenarios, devices, type);
  let rights = [];
  if (filteredScenarios) {
    _forEach(filteredScenarios, (scenario) => {
      rights = _concat(rights, _map(mScenario.filterTriggersByAccessWayType(scenario, devices, type), (scenarioTrigger) => ({
        scenario_trigger_id: scenarioTrigger.id,
        enabled: true,
      })));
    });
  }
  return rights;
};

/**
* Model
*/
const right = {
  // Name
  name: 'right',

  // Serializer
  serialize: serializeRight,

  // Sort elements
  sortElements: sortRights,

  // Utils
  isEqual: rightIsEqual,
  getAllFromAccessWayType: getAllRightsFromAccessWayType,
};

module.exports = right;



// WEBPACK FOOTER //
// ./models/right.js